// Calls
export const GET_PAYMENT_METHODS = "getPaymentMethods";
export const CLEAR_PM_AND_RATES_CACHE = "clearPmAndRatesCache";
export const GET_LOCALIZED_RATE = "getLocalizedRate";
export const GET_ORDER_DETAILS = "getOrderDetails";
export const VALIDATE_PACKAGE = "validatePackage";
export const CHECKOUT = "checkoutOrder";

// System data generators
export const CREATE_PAYLOAD = "createPayload";

// Merchant actions
export const FETCH_MERCHANT = "fetchMerchantInfo";
export const FETCH_BADGE = "fetchBadgeInfo";
export const FETCH_RATES = "fetchRates";

// General actions
export const GET_FINGERPRINT = "getFingerprint";
export const GET_MERCHANT_CURRENCY = "getCurrencyFormats";
export const GET_CUSTOMER_CURRENCY = "getCustomerCurrency";
export const GET_USER_IP = "getUserIpInfo";

// Session validation
export const CHECK_AUTH = "checkAuthentication";

// Init-ers
export const INITIALIZE_INVOICE = "initializeInvoiceData";
export const PRELOAD_INVOICE_DATA = "preloadInvoiceData";
export const LOAD_INVOICE_DATA_CACHE = "loadInvoiceDataFromCache";
export const LOCK_AND_LOAD_DATA = "lockAndLoadParam";
